import React, { useEffect, useMemo, useState } from 'react'
import filter from '../../images/sort 1.png'
import shield from '../../images/insurance (1) 1.png'
import laptop from '../../images/laptop 1.png'
import network from '../../images/network 1.png'
import { Chart } from "react-google-charts";
import { PieChart, Pie, Cell, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, AreaChart, Area, ResponsiveContainer } from "recharts";
import toast from 'react-hot-toast'
import HttpClient from "../../utils/HttpClient";
import './RiskManagement.css';
import moment from 'moment';
import CustomTaskDot from './CustomTaskDot'
import WaveChart from './WaveChart'
import TaskLineChart from './TaskLineChart'
import hamburger from '../../images/hamburger.png'
import { useLocation, useNavigate, useNavigation, useParams } from 'react-router-dom'

const RiskManagement = ({ taskAtRisk, taskCompleteStatus, taskDeviationAnalysis, setFeatures }) => {
    const navigate = useNavigate();
    const [openMenu, setOpenMenu] = useState(false);
    const [dateRange, setDateRange] = useState({
        startDate: null,
        endDate: null,
    });
    const [allProjects, setAllProjects] = useState([]);
    const [selectedProjectId, setSelectedProjectId] = useState('');
    const [selectedPhaseId, setSelectedPhaseId] = useState('');
    const [riskData, setRiskData] = useState({
        withinTimeAndCompleted: [],
        timeCrossedAndCompleted: [],
        timeCrossedAndNotCompleted: [],
        withinTimeAndNotCompleted: [],
    });
    const [riskData2, setRiskData2] = useState({
        withinTimeAndCompleted: [],
        timeCrossedAndCompleted: [],
        timeCrossedAndNotCompleted: [],
        withinTimeAndNotCompleted: [],
    });
    const [loading, setLoading] = useState(false);

    const [phases, setPhases] = useState([]);

    // Static data fallbacks
    const data = [
        { name: "Page A", uv: 4000, pv: 2400, amt: 2400 },
        { name: "Page B", uv: 3000, pv: 1398, amt: 2210 },
        { name: "Page C", uv: 2000, pv: 9800, amt: 2290 },
        { name: "Page D", uv: 2780, pv: 3908, amt: 2000 },
        { name: "Page E", uv: 1890, pv: 4800, amt: 2181 },
        { name: "Page F", uv: 2390, pv: 3800, amt: 2500 },
        { name: "Page G", uv: 3490, pv: 4300, amt: 2100 }
    ];

    const data3 = [
        ["Task", "Hours per Day"],
        ["Completed Tasks", 0],
        ["Pending Tasks", 0],
    ];

    const options = {
        pieHole: 0.6,
        is3D: false,
        colors: ['#0c2637', '#FFDD00'],
        label: false
    };

    // First, let's create a utility function to filter tasks by date range
    const filterTasksByDate = (tasks) => {
        if (!dateRange.startDate && !dateRange.endDate) return tasks;

        return tasks.filter(task => {
            const taskDate = new Date(task.selectDate);
            return (
                (!dateRange.startDate || taskDate >= dateRange.startDate) &&
                (!dateRange.endDate || taskDate <= dateRange.endDate)
            );
        });
    };

    // Transform data for project-wise task status bar chart
    const projectTaskStatusData = useMemo(() => {
        const allTasks = filterTasksByDate([
            ...riskData.withinTimeAndCompleted,
            ...riskData.timeCrossedAndCompleted,
            ...riskData.timeCrossedAndNotCompleted,
            ...riskData.withinTimeAndNotCompleted
        ]);

        return allTasks.map(task => {
            const selectDate = new Date(task.selectDate);
            const completionDate = task.doneOn ? new Date(task.doneOn) : new Date();
            const daysDifference = Math.floor((completionDate - selectDate) / (1000 * 60 * 60 * 24));

            let status, color;

            // if (task.taskStatus === 'done') {
            //     if (daysDifference <= 0) {
            //         status = 'Completed (On Time)';
            //         color = '#4CAF50'; // green
            //     } else {
            //         status = 'Completed (Late)';
            //         color = '#F44336'; // red
            //     }
            // } else {
            //     if (daysDifference <= 0) {
            //         status = 'Pending (On Time)';
            //         color = '#FFC107'; // yellow
            //     } else {
            //         status = 'Pending (Late)';
            //         color = '#FF9800'; // orange
            //     }
            // }
            if (task?.Milestone_Delivered) {
                status = 'Completed (On Time)';
                color = '#4CAF50'; // green
            } else if (task?.statusNote === "Still Pending – Past Due") {
                status = 'Pending (Late)';
                color = '#FF9800'; // orange
            } else if (task?.riskLevel) {
                status = 'Pending (On Time)';
                color = '#FFC107'; // yellow
            } else if (task?.statusNote === "Completed with Delay") {
                status = 'Completed (Late)';
                color = '#F44336'; // red
            }

            return {
                name: task.taskName,
                estimatedDurationDays: task?.estimatedDurationDays,
                actualCompletionDays: task?.actualCompletionDays,
                taskNotes: task?.taskNotes,
                statusNote: task?.statusNote,
                startDate: task?.selectDate,
                endDate: task?.endDate,
                startTime: task?.startTime,
                endTime: task?.endTime,
                role: task?.userType,
                Milestone_Delivered: task?.Milestone_Delivered,
                timeElapsedDays: task?.timeElapsedDays,
                user: task?.assignToUser,
                project: task?.assignToProject,
                riskLevel: task?.riskLevel,
                completionDays: Math.abs(daysDifference), // Changed from 'days' to 'completionDays'
                status,
                color,
                actualDays: daysDifference,
                plannedDate: new Date(task.endDate).toLocaleDateString('en-US', {
                    year: 'numeric',
                    month: 'short',
                    day: 'numeric'
                }),
                completionDate: task.doneOn ? new Date(task.doneOn).toLocaleDateString('en-US', {
                    year: 'numeric',
                    month: 'short',
                    day: 'numeric'
                }) : 'Not completed'
            };
        });
    }, [riskData, dateRange.startDate, dateRange.endDate]);

    // Transform data for deviation analysis
    const deviationTaskStatusData = useMemo(() => {
        const allTasks = filterTasksByDate([
            ...riskData2.withinTimeAndCompleted,
            ...riskData2.timeCrossedAndCompleted,
            ...riskData2.timeCrossedAndNotCompleted,
            ...riskData2.withinTimeAndNotCompleted,
        ]);

        return allTasks.map(task => {
            const selectDate = new Date(task.selectDate);
            const completionDate = task.doneOn ? new Date(task.doneOn) : new Date();
            const daysDifference = Math.floor((completionDate - selectDate) / (1000 * 60 * 60 * 24));

            let status, color;

            // if (task.taskStatus === 'done') {
            //     if (daysDifference < 0) {
            //         status = 'Profit';
            //         color = '#4CAF50'; // green
            //     } else if (daysDifference === 0) {
            //         status = 'Normal';
            //         color = '#FFC107'; // yellow
            //     } else {
            //         status = 'Risk';
            //         color = '#F44336'; // red
            //     }
            // } else {
            //     if (daysDifference <= 0) {
            //         status = 'Normal';
            //         color = '#FFC107'; // yellow
            //     } else {
            //         status = 'Deviation';
            //         color = '#FF9800'; // orange
            //     }
            // }
            if (task?.devition_Type === "Positive Schedule Gain") {
                status = 'Profit';
                color = '#4CAF50'; // green
            } else if (task?.devition_Type === "Scheduling Delay") {
                status = 'Risk';
                color = '#F44336'; // red
            } else if (task?.devition_Type === "Forecasted Scheduling Risk") {
                status = 'Deviation';
                color = '#FF9800'; // orange
            } else {
                status = 'Normal';
                color = '#FFC107'; // yellow
            }

            return {
                name: task.taskName,
                startDate: task?.selectDate,
                endDate: task?.endDate,
                startTime: task?.startTime,
                endTime: task?.endTime,
                project: task?.assignToProject,
                user: task?.assignToUser,
                assignedToPhase: phases?.find(phase => phase?._id === selectedPhaseId)?.name || '',
                completionDays: Math.abs(daysDifference), // Changed from 'days' to 'completionDays'
                role: task?.userType,
                estimatedDurationDays: task?.estimatedDurationDays,
                actualDuration: task?.actualCompletionDays,
                estimatedDuration: task?.estimatedDuration, // for red only
                aheadOfSchedeule: task?.aheadOfSchedeule,
                elaspedTime: task?.actualCompletionDays,
                behindSchedule: task?.behindSchedule,
                statusNote: task?.statusNote,
                status: task?.status,
                deviationType: task?.devition_Type,
                efficiency_Boost: task?.efficiency_Boost,
                phaseImpact: task?.phaseImpact,
                budgetGainFromDeviation: task?.budgetGainFromDeviation,
                elapsedTime: task?.elapsedTime,
                completitionStatus: task?.completitionStatus,
                budgetDeviation: task?.budgetDeviation,
                OnTime_completion: task?.OnTime_completion,
                delay: task?.delay,
                Timeline_Deviation: task?.Timeline_Deviation,
                budgetVaritaion: task?.budgetVaritaion,
                totalTask: task?.totalTask,
                completed: task?.completed,
                budget_Risk: task?.budget_Risk,
                budgetGain: task?.budgetGain,
                color,
                actualDays: daysDifference,
                plannedDate: new Date(task.endDate).toLocaleDateString('en-US', {
                    year: 'numeric',
                    month: 'short',
                    day: 'numeric'
                }),
                completionDate: task.doneOn ? new Date(task.doneOn).toLocaleDateString('en-US', {
                    year: 'numeric',
                    month: 'short',
                    day: 'numeric'
                }) : 'Not completed'
            };
        });
    }, [riskData2, dateRange.startDate, dateRange.endDate]);


    // Custom Tooltip Component for Task
    const CustomTooltip = ({ active, payload, label }) => {
        if (active && payload && payload.length) {
            const data = payload[0].payload;
            console.log("data >>>>>> ", data);

            return (
                <div className="custom-tooltip" style={{
                    background: '#fff',
                    padding: '10px',
                    border: '1px solid #ccc',
                    borderRadius: '4px',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                    zIndex: 1000,
                }}>
                    <div className='tooltip_bar_wrapper22' style={{
                        fontWeight: 600,
                    }}>
                        <p><strong>Project:</strong> {data.project}</p>
                        <p><strong>Assigned To:</strong> {Array.isArray(data.user) ? data.user.join(", ") : data.user}</p>
                        <p><strong>Role:</strong> {data.role}</p>
                        <p><strong>Start Date:</strong> {data.startDate?.split("T")?.[0]}, {data?.startTime}</p>
                        <p><strong>Start Date:</strong> {data.endDate?.split('T')?.[0]}, {data?.endTime}</p>
                    </div>
                    <p>⏱ Timeline & Status:</p>
                    <div className='tooltip_bar_wrapper' style={{
                        marginLeft: "40px",
                        fontWeight: 600,
                    }}>
                        <p><strong>Task:</strong> {data.name}</p>
                        <p><strong>Status:</strong> {data.status}</p>
                        {
                            data?.estimatedDurationDays && <p><strong>Estimated Duration:</strong> {data.estimatedDurationDays} days</p>
                        }
                        {
                            data?.actualCompletionDays && <p><strong>Actual Completion:</strong> {data.actualCompletionDays} days</p>
                        }
                        {
                            data?.timeElapsedDays && <p><strong>Elasped Time:</strong> {data.timeElapsedDays} days</p>
                        }
                        {/* <p><strong>Actual Date:</strong> {data.plannedDate}</p>
                        <p><strong>Completion Date:</strong> {data.completionDate}</p> */}
                        {
                            data?.actualCompletionDays && <p><strong>Actual Completion Date:</strong> {data.user}</p>
                        }
                        {
                            data?.statusNote && <p><strong>Status:</strong> {data.statusNote}</p>
                        }
                    </div>
                    <p style={{
                        marginTop: '10px',
                        fontWeight: 600,
                    }}>📊 Performance Insight:</p>
                    <div className='tooltip_bar_wrapper' style={{
                        marginLeft: "40px"
                    }}>
                        {
                            data?.statusNote === "Completed with Delay" && (<p><strong>Delay Reason:</strong> {data.taskNotes}</p>)
                        }
                        {
                            data?.statusNote === "Still Pending – Past Due" && (<p><strong>Pending Reason:</strong> {data.taskNotes}</p>)
                        }
                        {
                            data?.Milestone_Delivered && (<p><strong>Milestone Delivered:</strong> {data.Milestone_Delivered}</p>)
                        }
                        {
                            data?.riskLevel && (<p><strong>Risk Level:</strong> {data?.riskLevel === "low" ? '🟢 Low' : '🟥 High'}</p>)
                        }
                    </div>
                </div>
            );
        }
        return null;
    };

    // Custom Tooltip Component for Deviation
    const CustomTooltipForDevistion = ({ active, payload, label }) => {
        if (active && payload && payload.length) {
            const data = payload[0].payload;
            console.log("data >>>>>> ", data);

            return (
                <div className="custom-tooltip" style={{
                    background: '#fff',
                    padding: '10px',
                    border: '1px solid #ccc',
                    borderRadius: '4px',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                }}>
                    <div className='tooltip_bar_wrapper22' style={{
                        fontWeight: 600,
                    }}>
                        <p><strong>Project:</strong> {data.project}{data?.assignedToPhase && `.${data?.assignedToPhase}`}</p>
                        <p><strong>Assigned To:</strong> {Array.isArray(data.user) ? data.user.join(", ") : data.user}</p>
                        <p><strong>Start Date:</strong> {data?.startDate?.split("T")?.[0]}, {data?.startTime}</p>
                        <p><strong>End Date:</strong> {data?.endDate?.split("T")?.[0]}, {data?.endTime}</p>
                    </div>
                    {
                        data?.deviationType && (data?.deviationType === "Positive Schedule Gain" || data?.deviationType === "Scheduling Delay") && (
                            <>
                                <p>⏱ Timeline & Status:</p>
                                <div className='tooltip_bar_wrapper' style={{
                                    marginLeft: "40px",
                                    fontWeight: 600,
                                }}>
                                    {
                                        data?.estimatedDuration && <p><strong>Estimated Duration:</strong> {data.estimatedDuration} days</p>
                                    }
                                    {
                                        data?.elapsedTime && <p><strong>Elasped Time:</strong> {data.elapsedTime}</p>
                                    }
                                    {
                                        data?.behindSchedule && <p><strong>Behind Schedule:</strong> {data.behindSchedule}</p>
                                    }
                                    {
                                        data?.completitionStatus && <p><strong>Completion Status:</strong> {data.completitionStatus}</p>
                                    }
                                    {
                                        data?.estimatedDurationDays && <p><strong>Estimated Duration Days:</strong> {data.estimatedDurationDays} daya</p>
                                    }
                                    {
                                        data?.actualDuration && <p><strong>Actual Completion Days:</strong> {data.actualDuration} days</p>
                                    }
                                </div>
                            </>
                        )
                    }
                    {
                        data?.deviationType && (data?.deviationType === "Positive Schedule Gain" || data?.deviationType === "Scheduling Delay" || data?.deviationType === "Forecasted Scheduling Risk") && (
                            <>
                                <p>📊 Deviation Insights:</p>
                                <div className='tooltip_bar_wrapper' style={{
                                    marginLeft: "40px",
                                    fontWeight: 600,
                                }}>
                                    {
                                        data?.deviationType && <p><strong>Deviation Type:</strong> {data.deviationType}</p>
                                    }
                                </div>
                            </>
                        )
                    }

                    {
                        data?.OnTime_completion && (
                            <>
                                <p>📆 Planned Timeline:</p>
                                <div className='tooltip_bar_wrapper' style={{
                                    marginLeft: "40px",
                                    fontWeight: 600,
                                }}>
                                    <p><strong>Start:</strong> {moment(data?.startDate).format('DD MMM')}</p>
                                </div>
                            </>
                        )
                    }

                    {
                        data?.OnTime_completion && (
                            <>
                                <p>📆 Actual Timeline:</p>
                                <div className='tooltip_bar_wrapper' style={{
                                    marginLeft: "40px",
                                    fontWeight: 600,
                                }}>
                                    <p><strong>End:</strong> {moment(data?.endDate).format('DD MMM')}</p>
                                </div>
                            </>
                        )
                    }

                    {
                        data?.OnTime_completion && (
                            <>
                                <p>📊 Status Snapshot:</p>
                                <div className='tooltip_bar_wrapper' style={{
                                    marginLeft: "40px",
                                    fontWeight: 600,
                                }}>
                                    {
                                        data?.totalTask && <p><strong>Total Task:</strong> {data.totalTask}</p>
                                    }
                                    {
                                        data?.completed && <p><strong>Completed:</strong> {data.completed}</p>
                                    }
                                    {
                                        data?.OnTime_completion && <p><strong>On Time Completion:</strong> {data.OnTime_completion}</p>
                                    }
                                    {
                                        data?.delay && <p><strong>Delays:</strong> {data.delay}</p>
                                    }
                                    {
                                        data?.Timeline_Deviation && <p><strong>Timeline Deviation:</strong> {data.Timeline_Deviation}</p>
                                    }
                                </div>
                            </>
                        )
                    }

                    <p>💰 Financial & Scope Impact:</p>
                    <div className='tooltip_bar_wrapper' style={{
                        marginLeft: "40px",
                        fontWeight: 600,
                    }}>
                        {
                            data?.budgetDeviation && <p><strong>Budget Deviation:</strong> {data.budgetDeviation}</p>
                        }
                        {
                            data?.budgetGain && <p><strong>Budget Gain:</strong> {data.budgetGain}</p>
                        }
                        {
                            data?.budgetVaritaion && <p><strong>Budget Variation:</strong> {data.budgetVaritaion}</p>
                        }
                        {
                            data?.budget_Risk && <p><strong>Budget Risk:</strong> {data.budget_Risk}</p>
                        }
                    </div>
                </div>
            );
        }
        return null;
    };

    // Transform data for monthly task status
    // const monthlyTaskStatusData = useMemo(() => {
    //     const allTasks = filterTasksByDate([
    //         ...riskData.withinTimeAndCompleted,
    //         ...riskData.timeCrossedAndCompleted,
    //         ...riskData.timeCrossedAndNotCompleted,
    //         ...riskData.withinTimeAndNotCompleted
    //     ]);
    //     if (allTasks.length === 0) return [];

    //     // Group by month and count each status
    //     const statusCounts = allTasks.reduce((acc, task) => {
    //         const date = new Date(task.selectDate);
    //         const month = date.toLocaleString('default', { month: 'short' });
    //         const status = task.taskStatus;

    //         if (!acc[month]) {
    //             acc[month] = {
    //                 name: month,
    //                 open: 0,
    //                 doing: 0,
    //                 done: 0,
    //                 ideas: 0,
    //                 hold: 0
    //             };
    //         }

    //         if (status === 'open') acc[month].open++;
    //         else if (status === 'doing') acc[month].doing++;
    //         else if (status === 'done') acc[month].done++;
    //         else if (status === 'ideas') acc[month].ideas++;
    //         else if (status === 'hold') acc[month].hold++;
    //         else acc[month].open++; // default to open if status not recognized

    //         return acc;
    //     }, {});

    //     // Convert to array and add uv property that matches the sum of tasks for each month
    //     return Object.values(statusCounts).map(monthData => ({
    //         name: monthData.name,
    //         uv: monthData.open + monthData.doing + monthData.done + monthData.ideas + monthData.hold,
    //         pv: monthData.done, // completed tasks
    //         amt: monthData.open + monthData.doing + monthData.ideas + monthData.hold, // pending tasks
    //         open: monthData.open,
    //         doing: monthData.doing,
    //         done: monthData.done,
    //         ideas: monthData.ideas,
    //         hold: monthData.hold
    //     }));
    // }, [riskData, dateRange.startDate, dateRange.endDate, selectedProjectId, selectedPhaseId]);


    // Transform data for monthly task status
    const monthlyTaskStatusData = useMemo(() => {
        // Combine all tasks from the API response
        const allTasks = [
            ...riskData.withinTimeAndCompleted,
            ...riskData.timeCrossedAndCompleted,
            ...riskData.timeCrossedAndNotCompleted,
            ...riskData.withinTimeAndNotCompleted
        ];

        // Filter by date range if specified
        const filteredTasks = filterTasksByDate(allTasks);
        if (filteredTasks.length === 0) return [];

        // Group by month and count each status
        const statusCounts = filteredTasks.reduce((acc, task) => {
            const date = new Date(task.selectDate);
            const month = date.toLocaleString('default', { month: 'short' });
            const status = task.taskStatus;

            if (!acc[month]) {
                acc[month] = {
                    name: month,
                    open: 0,
                    doing: 0,
                    done: 0,
                    ideas: 0,
                    hold: 0
                };
            }

            // Count tasks by their actual status
            if (status === 'open') acc[month].open++;
            else if (status === 'doing') acc[month].doing++;
            else if (status === 'done') acc[month].done++;
            else if (status === 'ideas') acc[month].ideas++;
            else if (status === 'onhold') acc[month].hold++; // Note: API uses 'onhold' not 'hold'
            else acc[month].open++; // default to open if status not recognized

            return acc;
        }, {});

        // Convert to array and add uv property that matches the sum of tasks for each month
        return Object.values(statusCounts).map(monthData => ({
            name: monthData.name,
            uv: monthData.open + monthData.doing + monthData.done + monthData.ideas + monthData.hold,
            pv: monthData.done, // completed tasks
            amt: monthData.open + monthData.doing + monthData.ideas + monthData.hold, // pending tasks
            open: monthData.open,
            doing: monthData.doing,
            done: monthData.done,
            ideas: monthData.ideas,
            hold: monthData.hold
        }));
    }, [riskData, dateRange.startDate, dateRange.endDate, selectedProjectId, selectedPhaseId]);

    // Transform risk data for pie chart
    const transformedPieData = useMemo(() => {
        const completedTasks = filterTasksByDate([
            ...riskData.withinTimeAndCompleted,
            ...riskData.timeCrossedAndCompleted
        ]).length;

        const pendingTasks = filterTasksByDate([
            ...riskData.timeCrossedAndNotCompleted,
            ...riskData.withinTimeAndNotCompleted
        ]).length;

        return [
            ["Task", "Hours per Day"],
            ["Completed Tasks", completedTasks],
            ["Pending Tasks", pendingTasks]
        ];
    }, [riskData, dateRange.startDate, dateRange.endDate]);


    // Calculate statistics for cards
    const cardStats = useMemo(() => {
        const allTasks = filterTasksByDate([
            ...riskData.withinTimeAndCompleted,
            ...riskData.timeCrossedAndCompleted,
            ...riskData.timeCrossedAndNotCompleted,
            ...riskData.withinTimeAndNotCompleted
        ]);

        const completedTasks = filterTasksByDate([
            ...riskData.withinTimeAndCompleted,
            ...riskData.timeCrossedAndCompleted
        ]).length;

        const pendingTasks = filterTasksByDate([
            ...riskData.timeCrossedAndNotCompleted,
            ...riskData.withinTimeAndNotCompleted
        ]).length;

        const onTimeTasks = filterTasksByDate([
            ...riskData.withinTimeAndCompleted,
            ...riskData.withinTimeAndNotCompleted
        ]).length;

        const lateTasks = filterTasksByDate([
            ...riskData.timeCrossedAndCompleted,
            ...riskData.timeCrossedAndNotCompleted
        ]).length;

        return {
            totalTasks: allTasks.length,
            completedPercentage: allTasks.length > 0 ? Math.round((completedTasks / allTasks.length) * 100) : 0,
            pendingPercentage: allTasks.length > 0 ? Math.round((pendingTasks / allTasks.length) * 100) : 0,
            onTimePercentage: allTasks.length > 0 ? Math.round((onTimeTasks / allTasks.length) * 100) : 0,
            latePercentage: allTasks.length > 0 ? Math.round((lateTasks / allTasks.length) * 100) : 0
        };
    }, [riskData, dateRange.startDate, dateRange.endDate]);

    const fetchAllProjects = async () => {
        try {
            const res = await HttpClient.requestData('view-all-project', 'GET');
            if (res && res?.status) {
                setAllProjects(res?.data);
            } else {
                setAllProjects([]);
                toast.error(res?.message || 'Something went wrong!');
            }
        } catch (error) {
            setAllProjects([]);
            toast.error(error?.message || 'Something went wrong!');
        }
    };

    const fetchAllRiskDataByProjectId = async (projectId) => {
        setLoading(true);
        try {
            const res = await HttpClient.requestData('myriskedprojecttaskdetails', 'POST', {
                projectId,
            });
            if (res && res?.status) {
                setRiskData(res?.data);
            } else {
                setRiskData({
                    withinTimeAndCompleted: [],
                    timeCrossedAndCompleted: [],
                    timeCrossedAndNotCompleted: [],
                    withinTimeAndNotCompleted: [],
                });
                toast.error(res?.message || 'Something went wrong!');
            }
        } catch (error) {
            setRiskData({
                withinTimeAndCompleted: [],
                timeCrossedAndCompleted: [],
                timeCrossedAndNotCompleted: [],
                withinTimeAndNotCompleted: [],
            });
            toast.error(error?.message || 'Something went wrong!');
        } finally {
            setLoading(false);
        }
    };

    const fetchAllDeviationData = async (userData) => {
        setLoading(true);
        try {
            let dataToSubmit = {};
            Object.keys(userData)?.forEach(attr => {
                dataToSubmit[attr] = userData[attr];
            });
            // console.log("dataToSubmit: >>>> ", dataToSubmit);

            const res = await HttpClient.requestData('riskdetailswithDivition', 'POST', dataToSubmit);
            if (res && res?.status) {
                setRiskData2(res?.data);
            } else {
                setRiskData2({
                    withinTimeAndCompleted: [],
                    timeCrossedAndCompleted: [],
                    timeCrossedAndNotCompleted: [],
                    withinTimeAndNotCompleted: [],
                });
                toast.error(res?.message || 'Something went wrong!');
            }
        } catch (error) {
            setRiskData2({
                withinTimeAndCompleted: [],
                timeCrossedAndCompleted: [],
                timeCrossedAndNotCompleted: [],
                withinTimeAndNotCompleted: [],
            });
            toast.error(error?.message || 'Something went wrong!');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchAllProjects();
    }, []);

    useEffect(() => {
        if (selectedProjectId?.length) {
            fetchAllRiskDataByProjectId(selectedProjectId);
        } else {
            // Reset data when no project is selected
            setRiskData({
                withinTimeAndCompleted: [],
                timeCrossedAndCompleted: [],
                timeCrossedAndNotCompleted: [],
                withinTimeAndNotCompleted: [],
            });
        }
    }, [selectedProjectId]);

    useEffect(() => {
        const fetchData = async () => {
            // Reset data first
            setRiskData2({
                withinTimeAndCompleted: [],
                timeCrossedAndCompleted: [],
                timeCrossedAndNotCompleted: [],
                withinTimeAndNotCompleted: [],
            });

            // Only proceed if we have at least a projectId
            if (!selectedProjectId?.length) return;

            // Prepare the base request data
            const requestData = { projectId: selectedProjectId };

            // Add phaseId if available
            if (selectedPhaseId?.length) {
                requestData.phaseId = selectedPhaseId;
            }

            // Add date range if both dates are available
            if (dateRange?.startDate && dateRange?.endDate) {
                // Format dates to YYYY-MM-DD strings
                const formatDate = (date) => {
                    if (!date) return null;
                    const d = new Date(date);
                    const year = d.getFullYear();
                    const month = String(d.getMonth() + 1).padStart(2, '0');
                    const day = String(d.getDate()).padStart(2, '0');
                    return `${year}-${month}-${day}`;
                };

                requestData.startDate = formatDate(dateRange.startDate);
                requestData.endDate = formatDate(dateRange.endDate);
            }

            // Make the API call with whatever parameters we have
            await fetchAllDeviationData(requestData);
        };

        fetchData();
    }, [selectedProjectId, selectedPhaseId, dateRange]);

    const handleDateChange = (type, value) => {
        setDateRange(prev => ({
            ...prev,
            [type]: value ? new Date(value) : null
        }));
    };

    console.log("monthlyTaskStatusData: ", monthlyTaskStatusData);

    // First, update the generateWaveData function to include task information
    const generateWaveData = (value, type, monthlyData, tasks = [], percentage = 0) => {
        // Filter tasks by type (open, doing, done, ideas, hold)
        const filteredTasks = tasks.filter(task => {
            // For "hold" status type, check for "onhold" status from API
            if (type === 'hold') {
                return task.taskStatus === 'onhold';
            }
            return task.taskStatus === type;
        });

        // If we have monthly data with at least 3 points, use that
        if (monthlyData && monthlyData.length >= 3) {
            return monthlyData.map((month) => ({
                name: month.name,
                value: month[type] || 0,
                tasks: filteredTasks.filter(task => {
                    const taskDate = new Date(task.selectDate);
                    return taskDate.getMonth() === new Date(month.name + ' 1, 2023').getMonth();
                })
            }));
        }

        // Fallback - generate synthetic wave data with at least 6 points
        const baseValue = value > 0 ? value : 1;
        const weeks = [
            { name: 'Week 1', value: baseValue, tasks: [] },
            { name: 'Week 2', value: baseValue, tasks: [] },
            { name: 'Week 3', value: baseValue, tasks: [] },
            { name: 'Week 4', value: baseValue, tasks: [] },
            { name: 'Week 5', value: baseValue, tasks: [] },
            { name: 'Week 6', value: baseValue, tasks: [] },
        ];

        // Distribute tasks evenly across weeks
        if (filteredTasks.length > 0) {
            const tasksPerWeek = Math.ceil(filteredTasks.length / weeks.length);
            for (let i = 0; i < filteredTasks.length; i++) {
                const weekIndex = Math.min(Math.floor(i / tasksPerWeek), weeks.length - 1);
                weeks[weekIndex].tasks.push(filteredTasks[i]);
            }
        }

        // Adjust wave pattern based on percentage
        if (percentage === 0) {
            return weeks.map(week => ({ ...week, value: 0 }));
        } else {
            // Calculate amplitude based on percentage
            // Scale amplitude: 100% -> 2.0, 50% -> 1.0, 0% -> 0.1
            const initialAmplitude = Math.max(0.1, (percentage / 100) * 2);
            // Decay rate to ensure wave doesn't grow again
            const decayRate = 0.3; // Controls how quickly the wave decays
            // Base frequency adjusted per card type for variation
            const frequencyFactors = {
                open: 1.0,
                doing: 1.2,
                done: 0.8,
                ideas: 1.1,
                hold: 0.9
            };
            const frequency = frequencyFactors[type] || 1.0;

            return weeks.map((week, index) => {
                // Use a single sine wave with decaying amplitude
                // Start with initial peak and decay over time
                const progress = index / (weeks.length - 1); // 0 to 1
                const currentAmplitude = initialAmplitude * Math.exp(-decayRate * index); // Exponential decay
                const sineValue = Math.sin(index * Math.PI * frequency);
                const value = baseValue * (1 + sineValue * currentAmplitude);

                // Ensure value doesn't go below baseValue to prevent upward growth after decay
                return {
                    ...week,
                    value: Math.max(baseValue * 0.5, value) // Minimum value to avoid flatline
                };
            });
        }
    };

    const handleSubmit = async e => {
        try {
            setLoading(true);
            e.preventDefault();
            if (!selectedProjectId) {
                return toast.error('Project Id is Required!!!');
            }
            if (!dateRange.startDate) {
                return toast.error('Start Date is Required!!!');
            }
            if (!dateRange.endDate) {
                return toast.error('End Date is Required!!!');
            }
            // Format dates to YYYY-MM-DD without time
            const formatDate = (date) => {
                if (!date) return null;
                const d = new Date(date);
                const year = d.getFullYear();
                const month = String(d.getMonth() + 1).padStart(2, '0');
                const day = String(d.getDate()).padStart(2, '0');
                return `${year}-${month}-${day}`;
            };

            const data = {
                projectId: selectedProjectId,
                fromDate: formatDate(dateRange?.startDate),
                toDate: formatDate(dateRange?.endDate),
            };

            const res = await HttpClient.requestData('myriskedprojecttaskdetails', 'POST', {
                ...data,
            });

            // console.log("res from search:>>>>> ", res?.data);

            if (res && res?.status) {
                setRiskData(res?.data);
            } else {
                setRiskData({
                    withinTimeAndCompleted: [],
                    timeCrossedAndCompleted: [],
                    timeCrossedAndNotCompleted: [],
                    withinTimeAndNotCompleted: [],
                });
                toast.error(res?.message || 'Something went wrong!');
            }
        } catch (error) {
            setRiskData({
                withinTimeAndCompleted: [],
                timeCrossedAndCompleted: [],
                timeCrossedAndNotCompleted: [],
                withinTimeAndNotCompleted: [],
            });
            toast.error(error?.message || 'Something went wrong!');
        } finally {
            setLoading(false);
        }

    };

    const RiskManagementCard = ({
        title,
        color,
        fillColor,
        monthlyTaskStatusData,
        cardStats,
        riskData,
        statusType,
    }) => {
        // Calculate percentage
        const percentage = cardStats.totalTasks > 0
            ? Math.round((monthlyTaskStatusData.reduce((sum, month) => sum + month[statusType], 0) /
                cardStats.totalTasks * 100))
            : 0;
        // Generate wave data with tasks
        const waveData = generateWaveData(
            monthlyTaskStatusData.reduce((sum, month) => sum + month[statusType], 0),
            statusType,
            monthlyTaskStatusData,
            filterTasksByDate([
                ...riskData.withinTimeAndCompleted,
                ...riskData.timeCrossedAndCompleted,
                ...riskData.timeCrossedAndNotCompleted,
                ...riskData.withinTimeAndNotCompleted
            ]),
            percentage // Pass the percentage
        );

        return (
            <div className='risk_management_card'>
                <h5>{title}</h5>
                <p>Last updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' })}</p>
                <div style={{ width: '100%', height: '70px', position: 'relative' }}>
                    <WaveChart
                        data={waveData}
                        color={color}
                        fillColor={fillColor}
                        width={700} // Adjust based on your container size
                        height={70}
                    />
                </div>
                <div className='riskmanage_percentage_wrapper'>
                    <h3>{monthlyTaskStatusData.reduce((sum, month) => sum + month[statusType], 0)}</h3>
                    <h6>Total {title}</h6>
                </div>
                <div className='riskmanage_percentage_wrapper'>
                    <h3>
                        {cardStats.totalTasks > 0
                            ? Math.round((monthlyTaskStatusData.reduce((sum, month) => sum + month[statusType], 0) /
                                cardStats.totalTasks * 100))
                            : 0}%
                    </h3>
                    <h6>Percentage</h6>
                </div>
            </div>
        );
    };

    const getExistingPhases = async projectId => {
        try {
            const res = await HttpClient.requestData(`phases/${projectId}`, 'GET');
            if (res && res.data) {
                setPhases(res?.data);
            } else {
                setPhases([]);
            }
        } catch (error) {
            toast.error(error?.message || 'Failed to load existing phases');
            setPhases([]);

        }
    };

    useEffect(() => {
        if (selectedProjectId) {
            getExistingPhases(selectedProjectId);
        }
    }, [selectedProjectId]);

    const [showUserModal, setShowUserModal] = useState(false);
    const [selectedTaskUsers, setSelectedTaskUsers] = useState([]);

    // Function to handle eye icon click
    const handleShowUsers = (task) => {
        setSelectedTaskUsers(task || []);
        setShowUserModal(true);
    };


    const [taskAtRiskData, setTaskAtRiskData] = useState([]);

    useEffect(() => {
        if (riskData) {
            setTaskAtRiskData([...riskData?.timeCrossedAndNotCompleted, ...riskData?.timeCrossedAndCompleted]);
        }
    }, [riskData]);

    const location = useLocation();

    // console.log("phases: ", phases);

    // User Modal Component
    const UserModal = ({ users, onClose }) => {
        return (
            <div style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0,0,0,0.5)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 1000
            }}>
                <div style={{
                    backgroundColor: 'white',
                    padding: '20px',
                    borderRadius: '8px',
                    maxWidth: '400px',
                    width: '90%',
                    maxHeight: '80vh',
                    overflowY: 'auto'
                }}>
                    <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginBottom: '15px',
                        borderBottom: '1px solid #eee',
                        paddingBottom: '10px'
                    }}>
                        <h4 style={{ margin: 0 }}>Assigned Users</h4>
                        <button
                            onClick={onClose}
                            style={{
                                background: 'none',
                                border: 'none',
                                fontSize: '18px',
                                cursor: 'pointer',
                                color: '#666'
                            }}
                        >
                            ×
                        </button>
                    </div>

                    {users.length > 0 ? (
                        <div>
                            {users.map((user, index) => (
                                <div key={index} style={{
                                    padding: '10px',
                                    border: '1px solid #eee',
                                    borderRadius: '4px',
                                    marginBottom: '8px',
                                    backgroundColor: '#f9f9f9'
                                }}>
                                    <strong>Name: {user?.name || '-'}</strong>
                                    <strong style={{ marginLeft: '10px' }}>Type: {user?.userType || '-'}</strong>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <p style={{ textAlign: 'center', color: '#666' }}>No users assigned</p>
                    )}

                    <div style={{ marginTop: '20px', textAlign: 'center' }}>
                        <button
                            onClick={onClose}
                            style={{
                                backgroundColor: '#0C2537',
                                color: 'white',
                                border: 'none',
                                padding: '8px 16px',
                                borderRadius: '4px',
                                cursor: 'pointer'
                            }}
                        >
                            Close
                        </button>
                    </div>
                </div>
            </div>
        );
    };

    console.log(`{
        taskCompleteStatus,
        taskAtRisk,
        taskDeviationAnalysis,
    }: `, {
        taskCompleteStatus,
        taskAtRisk,
        taskDeviationAnalysis,
    });
    const { togglePath } = useParams();

    return (
        <div className='risk_management_wrapper' style={{
            margin: togglePath !== undefined && "92px 0px",
        }}>
            {
                location?.pathname?.startsWith("/eventsCalender") && (
                    <div className='invoice_creation_head'>Risk Management
                        {
                            location.pathname !== "/eventsCalender" && (
                                <div className="menu-bar-wrp" style={{
                                    cursor: "ponter",
                                }} onClick={() => setOpenMenu((prev) => !prev)}>
                                    <img src={hamburger} alt="" />
                                    {openMenu && (
                                        <div className="menu-box-hm">
                                            <p onClick={(() => {
                                                setFeatures({
                                                    toggle0: true,
                                                    toggle1: false,
                                                    toggle2: false,
                                                    toggle3: false,
                                                    toggle4: false,
                                                    toggle5: false,
                                                    toggle6: false,
                                                    toggle7: false,
                                                    toggle8: false,
                                                    toggle9: false,
                                                    toggle10: false,
                                                });
                                                navigate("/eventsCalender/true")
                                            })}>Calendar</p>
                                            {/* <p onClick={(() => navigate("/eventsCalender/toggle5"))}>Risk management</p> */}
                                            <p>Prediction/Forecasting</p>
                                            <p>Budget & financials</p>
                                            <p>Chat monitor</p>
                                        </div>
                                    )}
                                </div>
                            )
                        }
                    </div>
                )
            }
            <div className='invoice_wrapper886464 ' style={{
                // border: '4px solid #fff',
                padding: '20px',
                borderRadius: '25px'
            }}>
                <div className='riskmanagement_dashboard_wrapper'>
                    <div className='riskmanagement_head_wrapper'>
                        <div className='riskmanage_head_buttons_wrapper'>
                            <div className='riskmanage_caledar_wrapper'>
                                <div className='riskmanage_calendar' style={{
                                    display: 'none',
                                }}>
                                    <i className="fa-regular fa-calendar"></i>
                                    {new Date().toLocaleString('default', { month: 'short' })} {new Date().getDate()}
                                </div>
                                <div className='riskmanage_dropdown'>
                                    <select
                                        value={selectedProjectId}
                                        onChange={(e) => setSelectedProjectId(e.target.value)}
                                        style={{ border: 'none', background: 'transparent' }}
                                    >
                                        <option value="">Select Project</option>
                                        {allProjects?.length > 0 ? allProjects.map(project => (
                                            <option key={project._id} value={project._id}>
                                                {project.projectName}
                                            </option>
                                        )) : (
                                            <option value="" disabled>No Projects Available</option>
                                        )}
                                    </select>
                                    {/* <i className="fa-solid fa-angle-down"></i> */}
                                </div>
                                <div className='riskmanage_dropdown'>
                                    <select
                                        value={selectedPhaseId}
                                        onChange={(e) => setSelectedPhaseId(e.target.value)}
                                        style={{ border: 'none', background: 'transparent', width: '180px' }}
                                    >
                                        <option value="">Select Phase</option>
                                        {phases?.length > 0 ? phases?.map(phase => (
                                            <option key={phase._id} value={phase._id}>
                                                {phase?.name}
                                            </option>
                                        )) : (
                                            <option value="" disabled>No Phases Available</option>
                                        )}
                                    </select>
                                    {/* <i className="fa-solid fa-angle-down"></i> */}
                                </div>
                            </div>

                            {/* Add Date Range Filter */}
                            <div className='date-range-filter'>
                                <div className='date-filter-item'>
                                    <label style={{
                                        color: '#0C2537',
                                    }}>From:</label>
                                    <input
                                        type="date"
                                        onChange={(e) => handleDateChange('startDate', e.target.value)}
                                        max={dateRange.endDate ? dateRange.endDate.toISOString().split('T')[0] : ''}
                                    />
                                </div>
                                <div className='date-filter-item'>
                                    <label style={{
                                        color: '#0C2537',
                                    }}>To:</label>
                                    <input
                                        type="date"
                                        onChange={(e) => handleDateChange('endDate', e.target.value)}
                                        min={dateRange.startDate ? dateRange.startDate.toISOString().split('T')[0] : ''}
                                    />
                                </div>
                                {/* <div className='gantt_input_Wrapper' style={{
                                }}>
                                     <div style={{
                                        background: '#0c2637',
                                        color: '#fff',
                                        cursor: 'pointer',
                                    }} className='filter_button5625' onClick={handleSubmit}>Submit</div> 
                                </div> */}
                            </div>

                            <div className='riskmanage_filter_button' style={{
                                display: 'none',
                            }}>
                                <img src={filter} alt='filter' />
                                Filter
                            </div>
                            <div className='riskmanage_export_button' style={{
                                display: 'none',
                            }}>
                                <i className="fa-solid fa-arrow-up-from-bracket"></i>
                                Export
                            </div>
                        </div>
                    </div>

                    {
                        location?.pathname?.startsWith("/eventsCalender") && (
                            <div className='riskmanagement_dashboard_container'>
                                <div className='risk_management_content_left'>
                                    <div className='risk_management_cards_Wrapper d-none'>

                                        {/* Total Tasks Card */}
                                        <div className='risk_management_card d-none'>
                                            <h5>Total Tasks</h5>
                                            <p>Last updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' })}</p>
                                            <ResponsiveContainer height={70} width={'100%'}>
                                                <AreaChart
                                                    width={'100%'}
                                                    height={'100%'}
                                                    data={data}
                                                    margin={{ top: 5, right: 0, left: 0, bottom: 5 }}
                                                >
                                                    <Area type="monotone" dataKey="uv" strokeWidth={3} stroke="#0C2537" fill="#4B5E6B" />
                                                </AreaChart>
                                            </ResponsiveContainer>
                                            <div className='riskmanage_percentage_wrapper'>
                                                <h3>{cardStats.totalTasks}</h3>
                                                <h6>Total</h6>
                                            </div>
                                            <div className='riskmanage_percentage_wrapper'>
                                                <h3>{cardStats.completedPercentage}%</h3>
                                                <h6>Completed</h6>
                                            </div>
                                            <div className='riskmanage_percentage_wrapper'>
                                                <h3>{cardStats.pendingPercentage}%</h3>
                                                <h6>Pending</h6>
                                            </div>
                                        </div>

                                        {/* Open Tasks Card */}
                                        <div className='risk_management_card'>
                                            <h5>Todo</h5>
                                            <p>Last updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' })}</p>
                                            <ResponsiveContainer height={70} width={'100%'}>
                                                <AreaChart
                                                    width={'100%'}
                                                    height={'100%'}
                                                    data={generateWaveData(
                                                        monthlyTaskStatusData.reduce((sum, month) => sum + month.open, 0),
                                                        'open',
                                                        monthlyTaskStatusData,
                                                        filterTasksByDate([
                                                            ...riskData.withinTimeAndCompleted,
                                                            ...riskData.timeCrossedAndCompleted,
                                                            ...riskData.timeCrossedAndNotCompleted,
                                                            ...riskData.withinTimeAndNotCompleted
                                                        ])
                                                    )}
                                                    margin={{ top: 5, right: 0, left: 0, bottom: 5 }}
                                                >
                                                    <Area
                                                        type="natural"  // Changed from monotone to natural for more organic wave
                                                        dataKey="value"
                                                        strokeWidth={2}
                                                        stroke="#FFC107"
                                                        fill="#FFECB3"
                                                        // dot={false}
                                                        dot={<CustomTaskDot />}
                                                        animationDuration={1500}
                                                    />
                                                    {/* <Tooltip content={<CustomTooltip />} />  */}
                                                </AreaChart>
                                            </ResponsiveContainer>
                                            <div className='riskmanage_percentage_wrapper'>
                                                <h3>{monthlyTaskStatusData.reduce((sum, month) => sum + month.open, 0)}</h3>
                                                <h6>Total Open</h6>
                                            </div>
                                            <div className='riskmanage_percentage_wrapper'>
                                                <h3>
                                                    {cardStats.totalTasks > 0 ? Math.round((monthlyTaskStatusData.reduce((sum, month) => sum + month.open, 0) / cardStats.totalTasks * 100)) : 0}%
                                                </h3>
                                                <h6>Percentage</h6>
                                            </div>
                                        </div>

                                        {/* Doing Tasks Card */}
                                        <div className='risk_management_card'>
                                            <h5>Doing</h5>
                                            <p>Last updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' })}</p>
                                            <ResponsiveContainer height={70} width={'100%'}>
                                                <AreaChart
                                                    width={'100%'}
                                                    height={'100%'}
                                                    data={generateWaveData(
                                                        monthlyTaskStatusData.reduce((sum, month) => sum + month.doing, 0),
                                                        'doing',
                                                        monthlyTaskStatusData,
                                                        filterTasksByDate([
                                                            ...riskData.withinTimeAndCompleted,
                                                            ...riskData.timeCrossedAndCompleted,
                                                            ...riskData.timeCrossedAndNotCompleted,
                                                            ...riskData.withinTimeAndNotCompleted
                                                        ])

                                                    )}
                                                    margin={{ top: 5, right: 0, left: 0, bottom: 5 }}
                                                >
                                                    <Area
                                                        type="natural"  // Changed from monotone to natural
                                                        dataKey="value"
                                                        strokeWidth={2}
                                                        stroke="#2196F3"
                                                        fill="#BBDEFB"
                                                        // dot={false}
                                                        dot={<CustomTaskDot />}
                                                        animationDuration={1500}
                                                    />
                                                </AreaChart>
                                            </ResponsiveContainer>
                                            <div className='riskmanage_percentage_wrapper'>
                                                <h3>{monthlyTaskStatusData.reduce((sum, month) => sum + month.doing, 0)}</h3>
                                                <h6>Total In Progress</h6>
                                            </div>
                                            <div className='riskmanage_percentage_wrapper'>
                                                <h3>
                                                    {cardStats.totalTasks > 0
                                                        ? Math.round((monthlyTaskStatusData.reduce((sum, month) => sum + month.doing, 0) / cardStats.totalTasks * 100))
                                                        : 0}%
                                                </h3>
                                                <h6>Percentage</h6>
                                            </div>
                                        </div>

                                        {/* Done Tasks Card */}
                                        <div className='risk_management_card'>
                                            <h5>Completed Tasks</h5>
                                            <p>Last updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' })}</p>
                                            <ResponsiveContainer height={70} width={'100%'}>
                                                <AreaChart
                                                    width={'100%'}
                                                    height={'100%'}
                                                    data={generateWaveData(
                                                        monthlyTaskStatusData.reduce((sum, month) => sum + month.done, 0),
                                                        'done',
                                                        monthlyTaskStatusData,
                                                        filterTasksByDate([
                                                            ...riskData.withinTimeAndCompleted,
                                                            ...riskData.timeCrossedAndCompleted,
                                                            ...riskData.timeCrossedAndNotCompleted,
                                                            ...riskData.withinTimeAndNotCompleted
                                                        ])
                                                    )}
                                                    margin={{ top: 5, right: 0, left: 0, bottom: 5 }}
                                                >
                                                    <Area
                                                        type="natural"  // Changed from monotone to natural
                                                        dataKey="value"
                                                        strokeWidth={2}
                                                        stroke="#4CAF50"
                                                        fill="#C8E6C9"
                                                        // dot={false}
                                                        dot={<CustomTaskDot />}
                                                        animationDuration={1500}
                                                    />
                                                </AreaChart>
                                            </ResponsiveContainer>
                                            <div className='riskmanage_percentage_wrapper'>
                                                <h3>{monthlyTaskStatusData.reduce((sum, month) => sum + month.done, 0)}</h3>
                                                <h6>Total Completed</h6>
                                            </div>
                                            <div className='riskmanage_percentage_wrapper'>
                                                <h3>
                                                    {cardStats.totalTasks > 0
                                                        ? Math.round((monthlyTaskStatusData.reduce((sum, month) => sum + month.done, 0) / cardStats.totalTasks * 100))
                                                        : 0}%
                                                </h3>
                                                <h6>Percentage</h6>
                                            </div>
                                        </div>

                                        {/* Ideas Tasks Card */}
                                        <div className='risk_management_card'>
                                            <h5>Ideas</h5>
                                            <p>Last updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' })}</p>
                                            <ResponsiveContainer height={70} width={'100%'}>
                                                <AreaChart
                                                    width={'100%'}
                                                    height={'100%'}
                                                    data={generateWaveData(
                                                        monthlyTaskStatusData.reduce((sum, month) => sum + month.ideas, 0),
                                                        'ideas',
                                                        monthlyTaskStatusData,
                                                        filterTasksByDate([
                                                            ...riskData.withinTimeAndCompleted,
                                                            ...riskData.timeCrossedAndCompleted,
                                                            ...riskData.timeCrossedAndNotCompleted,
                                                            ...riskData.withinTimeAndNotCompleted
                                                        ])
                                                    )}
                                                    margin={{ top: 5, right: 0, left: 0, bottom: 5 }}
                                                >
                                                    <Area
                                                        type="natural"  // Changed from monotone to natural
                                                        dataKey="value"
                                                        strokeWidth={2}
                                                        stroke="#9C27B0"
                                                        fill="#E1BEE7"
                                                        // dot={false}
                                                        dot={<CustomTaskDot />}
                                                        animationDuration={1500}
                                                    />
                                                </AreaChart>
                                            </ResponsiveContainer>
                                            <div className='riskmanage_percentage_wrapper'>
                                                <h3>{monthlyTaskStatusData.reduce((sum, month) => sum + month.ideas, 0)}</h3>
                                                <h6>Total Ideas</h6>
                                            </div>
                                            <div className='riskmanage_percentage_wrapper'>
                                                <h3>
                                                    {cardStats.totalTasks > 0
                                                        ? Math.round((monthlyTaskStatusData.reduce((sum, month) => sum + month.ideas, 0) / cardStats.totalTasks * 100))
                                                        : 0}%
                                                </h3>
                                                <h6>Percentage</h6>
                                            </div>
                                        </div>

                                        {/* On Hold Tasks Card */}
                                        <div className='risk_management_card'>
                                            <h5>On Hold</h5>
                                            <p>Last updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' })}</p>
                                            <ResponsiveContainer height={70} width={'100%'}>
                                                <AreaChart
                                                    width={'100%'}
                                                    height={'100%'}
                                                    data={generateWaveData(
                                                        monthlyTaskStatusData.reduce((sum, month) => sum + month.hold, 0),
                                                        'hold',
                                                        monthlyTaskStatusData,
                                                        filterTasksByDate([
                                                            ...riskData.withinTimeAndCompleted,
                                                            ...riskData.timeCrossedAndCompleted,
                                                            ...riskData.timeCrossedAndNotCompleted,
                                                            ...riskData.withinTimeAndNotCompleted
                                                        ])
                                                    )}
                                                    margin={{ top: 5, right: 0, left: 0, bottom: 5 }}
                                                >
                                                    <Area
                                                        type="natural"  // Changed from monotone to natural
                                                        dataKey="value"
                                                        strokeWidth={2}
                                                        stroke="#607D8B"
                                                        fill="#CFD8DC"
                                                        // dot={false}
                                                        dot={<CustomTaskDot />}
                                                        animationDuration={1500}
                                                    />
                                                </AreaChart>
                                            </ResponsiveContainer>
                                            <div className='riskmanage_percentage_wrapper'>
                                                <h3>{monthlyTaskStatusData.reduce((sum, month) => sum + month.hold, 0)}</h3>
                                                <h6>Total On Hold</h6>
                                            </div>
                                            <div className='riskmanage_percentage_wrapper'>
                                                <h3>
                                                    {cardStats.totalTasks > 0
                                                        ? Math.round((monthlyTaskStatusData.reduce((sum, month) => sum + month.hold, 0) / cardStats.totalTasks * 100))
                                                        : 0}%
                                                </h3>
                                                <h6>Percentage</h6>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='risk_management_cards_Wrapper'>
                                        {/* Open Tasks Card */}
                                        <RiskManagementCard
                                            title="Todo"
                                            color="#FFC107"
                                            fillColor="#FFECB3"
                                            monthlyTaskStatusData={monthlyTaskStatusData}
                                            cardStats={cardStats}
                                            riskData={riskData}
                                            statusType="open"
                                        />

                                        {/* Doing Tasks Card */}
                                        <RiskManagementCard
                                            title="Doing"
                                            color="#2196F3"
                                            fillColor="#BBDEFB"
                                            monthlyTaskStatusData={monthlyTaskStatusData}
                                            cardStats={cardStats}
                                            riskData={riskData}
                                            statusType="doing"
                                        />

                                        {/* Done Tasks Card */}
                                        <RiskManagementCard
                                            title="Completed Tasks"
                                            color="#4CAF50"
                                            fillColor="#C8E6C9"
                                            monthlyTaskStatusData={monthlyTaskStatusData}
                                            cardStats={cardStats}
                                            riskData={riskData}
                                            statusType="done"
                                        />

                                        {/* Ideas Tasks Card */}
                                        <RiskManagementCard
                                            title="Ideas"
                                            color="#9C27B0"
                                            fillColor="#E1BEE7"
                                            monthlyTaskStatusData={monthlyTaskStatusData}
                                            cardStats={cardStats}
                                            riskData={riskData}
                                            statusType="ideas"
                                        />

                                        {/* On Hold Tasks Card */}
                                        <RiskManagementCard
                                            title="On Hold"
                                            color="#607D8B"
                                            fillColor="#CFD8DC"
                                            monthlyTaskStatusData={monthlyTaskStatusData}
                                            cardStats={cardStats}
                                            riskData={riskData}
                                            statusType="hold"
                                        />
                                    </div>

                                    <div style={{
                                        display: 'flex',
                                        flexWrap: 'wrap',
                                        gap: '20px',
                                    }}>
                                        <div className='pro-task-wrp'>
                                            {/* Project Task Status Bar Chart */}
                                            <div className='average_risk_over_time_wrapper avregare-graph-rm' >
                                                <h5>Task Completion Status</h5>
                                                <div className='riskManagement_barchart_wrapper'>
                                                    {loading ? (
                                                        <div className="loading-spinner">Loading...</div>
                                                    ) : projectTaskStatusData.length > 0 ? (
                                                        <ResponsiveContainer width="100%" height={400}>
                                                            <BarChart
                                                                data={projectTaskStatusData}
                                                                margin={{ top: 20, right: 30, left: 20, bottom: 60 }}
                                                                layout="horizontal" // Changed to horizontal layout
                                                            >
                                                                <CartesianGrid strokeDasharray="3 3" />
                                                                <XAxis
                                                                    dataKey="name"
                                                                    tick={{ fontSize: 12 }}
                                                                    interval={0}
                                                                    height={70}
                                                                    angle={-45}
                                                                    textAnchor="end"
                                                                />
                                                                <YAxis
                                                                    type="number"
                                                                    label={{ value: 'Elasped Time', angle: -90, position: 'insideLeft' }}
                                                                />
                                                                <Tooltip content={<CustomTooltip />} />
                                                                <Legend />
                                                                <Bar dataKey="completionDays" name="Tasks">
                                                                    {projectTaskStatusData.map((entry, index) => (
                                                                        <Cell key={`cell-${index}`} fill={entry.color} />
                                                                    ))}
                                                                </Bar>
                                                            </BarChart>
                                                        </ResponsiveContainer>
                                                    ) : (
                                                        <div className="no-data-message">No task data available for the selected project</div>
                                                    )}
                                                </div>
                                                <div className='chart-legend' style={{ textAlign: 'center', marginTop: '10px' }}>
                                                    <div style={{ display: 'inline-block', margin: '0 10px' }}>
                                                        <span style={{ display: 'inline-block', width: '12px', height: '12px', backgroundColor: '#4CAF50', marginRight: '5px' }}></span>
                                                        <span>Completed (On Time)</span>
                                                    </div>
                                                    <div style={{ display: 'inline-block', margin: '0 10px' }}>
                                                        <span style={{ display: 'inline-block', width: '12px', height: '12px', backgroundColor: '#F44336', marginRight: '5px' }}></span>
                                                        <span>Completed (Late)</span>
                                                    </div>
                                                    <div style={{ display: 'inline-block', margin: '0 10px' }}>
                                                        <span style={{ display: 'inline-block', width: '12px', height: '12px', backgroundColor: '#FFC107', marginRight: '5px' }}></span>
                                                        <span>Pending (On Time)</span>
                                                    </div>
                                                    <div style={{ display: 'inline-block', margin: '0 10px' }}>
                                                        <span style={{ display: 'inline-block', width: '12px', height: '12px', backgroundColor: '#FF9800', marginRight: '5px' }}></span>
                                                        <span>Pending (Late)</span>
                                                    </div>
                                                </div>
                                            </div>


                                            {/* Task Deviation Analysis Bar Chart */}
                                            <div className='average_risk_over_time_wrapper avregare-graph-rm' >
                                                <h5>Task Deviation Analysis</h5>
                                                <div className='riskManagement_barchart_wrapper'>
                                                    {loading ? (
                                                        <div className="loading-spinner">Loading...</div>
                                                    ) : deviationTaskStatusData.length > 0 ? (
                                                        <ResponsiveContainer width="100%" height={400}>
                                                            <BarChart
                                                                data={deviationTaskStatusData}
                                                                margin={{ top: 20, right: 30, left: 20, bottom: 60 }}
                                                                layout="horizontal" // Changed to horizontal layout
                                                            >
                                                                <CartesianGrid strokeDasharray="3 3" />
                                                                <XAxis
                                                                    dataKey="name"
                                                                    tick={{ fontSize: 12 }}
                                                                    interval={0}
                                                                    height={70}
                                                                    angle={-45}
                                                                    textAnchor="end"
                                                                />
                                                                <YAxis
                                                                    type="number"
                                                                    label={{ value: 'Elapsed Time', angle: -90, position: 'insideLeft' }}
                                                                />
                                                                <Tooltip content={<CustomTooltipForDevistion />} />
                                                                <Legend />
                                                                <Bar dataKey="completionDays" name="Tasks">
                                                                    {deviationTaskStatusData.map((entry, index) => (
                                                                        <Cell key={`cell-${index}`} fill={entry.color} />
                                                                    ))}
                                                                </Bar>
                                                            </BarChart>
                                                        </ResponsiveContainer>
                                                    ) : (
                                                        <div className="no-data-message">No deviation data available for the selected project</div>
                                                    )}
                                                </div>
                                                <div className='chart-legend' style={{ textAlign: 'center', marginTop: '10px' }}>
                                                    <div style={{ display: 'inline-block', margin: '0 10px' }}>
                                                        <span style={{ display: 'inline-block', width: '12px', height: '12px', backgroundColor: '#4CAF50', marginRight: '5px' }}></span>
                                                        <span>Profit (Early Completion)</span>
                                                    </div>
                                                    <div style={{ display: 'inline-block', margin: '0 10px' }}>
                                                        <span style={{ display: 'inline-block', width: '12px', height: '12px', backgroundColor: '#FFC107', marginRight: '5px' }}></span>
                                                        <span>Normal (On Time)</span>
                                                    </div>
                                                    <div style={{ display: 'inline-block', margin: '0 10px' }}>
                                                        <span style={{ display: 'inline-block', width: '12px', height: '12px', backgroundColor: '#F44336', marginRight: '5px' }}></span>
                                                        <span>Risk (Late Completion)</span>
                                                    </div>
                                                    <div style={{ display: 'inline-block', margin: '0 10px' }}>
                                                        <span style={{ display: 'inline-block', width: '12px', height: '12px', backgroundColor: '#FF9800', marginRight: '5px' }}></span>
                                                        <span>Deviation (Pending Late)</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {/** Risked Tasks Table **/}
                                        <div className='average_risk_over_time_wrapper' style={{ width: '100%' }}>
                                            <h5>Tasks At-Risk</h5>
                                            {/* Table container with fixed height and scroll */}
                                            <div style={{
                                                maxHeight: '300px',
                                                overflow: 'auto',
                                                marginTop: '10px',
                                                border: '1px solid #e0e0e0',
                                                borderRadius: '4px'
                                            }}>
                                                <table style={{
                                                    width: '100%',
                                                    borderCollapse: 'collapse'
                                                }}>
                                                    <thead style={{
                                                        position: 'sticky',
                                                        top: 0,
                                                        backgroundColor: '#0C2537',
                                                        color: 'white',
                                                        fontSize: '13px'
                                                    }}>
                                                        <tr>
                                                            <th style={{ padding: '8px', textAlign: 'left' }}>Task Name</th>
                                                            <th style={{ padding: '8px', textAlign: 'left' }}>Team Member</th>
                                                            <th style={{ padding: '8px', textAlign: 'left' }}>Task Status</th>
                                                            <th style={{ padding: '8px', textAlign: 'left' }}>Days Behind</th>
                                                            <th style={{ padding: '8px', textAlign: 'left' }}>Days Past Due</th>
                                                            <th style={{ padding: '8px', textAlign: 'left' }}>Remaining Days</th>
                                                            <th style={{ padding: '8px', textAlign: 'left' }}>Task Completion Date</th>
                                                            <th style={{ padding: '8px', textAlign: 'left' }}>Task Due Date</th>
                                                            <th style={{ padding: '8px', textAlign: 'left' }}>Project Due Date</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            taskAtRiskData?.length > 0 ? taskAtRiskData?.map((task, index) => {

                                                                return (<tr key={index} style={{
                                                                    borderBottom: '1px solid #e0e0e0',
                                                                    // backgroundColor: index % 2 === 0 ? '#f9f9f9' : 'white'
                                                                }}>
                                                                    <td style={{ padding: '8px' }}>{task.taskName || '-'}</td>
                                                                    <td style={{ padding: '8px', textAlign: 'center' }}>
                                                                        <button
                                                                            onClick={() => handleShowUsers(task?.assignedUsers || [])}
                                                                            style={{
                                                                                background: 'none',
                                                                                border: 'none',
                                                                                cursor: 'pointer',
                                                                                color: '#0C2537',
                                                                                fontSize: '16px'
                                                                            }}
                                                                            title="View Assigned Users"
                                                                        >
                                                                            <i className="fa-solid fa-eye"></i>
                                                                        </button>
                                                                    </td>
                                                                    <td style={{ padding: '8px' }}>{task?.statusNote || '-'}</td>
                                                                    <td style={{
                                                                        padding: '8px',
                                                                        color: task?.daysBehind < 0 ? 'red' : task?.daysBehind > 0 ? 'green' : 'inherit'
                                                                    }}>{task?.doneOn ? task?.daysBehind : '-'}</td>
                                                                    <td style={{
                                                                        padding: '8px',
                                                                        color: task?.pastDue < 0 ? 'red' : task?.pastDue > 0 ? 'green' : 'inherit'
                                                                    }}>{task?.pastDue}</td>
                                                                    <td style={{
                                                                        padding: '8px',
                                                                        color: task?.remainingDays < 0 ? 'red' : task?.remainingDays > 0 ? 'green' : 'inherit'
                                                                    }}>{task?.remainingDays}</td>
                                                                    <td style={{ padding: '8px' }}>{task?.doneOn ? moment(task.doneOn).format('MMM D, YYYY') : '-'}</td>
                                                                    <td style={{ padding: '8px' }}>
                                                                        {task.endDate ? moment(task.endDate).format('MMM D, YYYY') : '-'}
                                                                    </td>
                                                                    <td style={{ padding: '8px' }}>
                                                                        {moment(task.projectEndDate).format('MMM D, YYYY')}
                                                                    </td>
                                                                </tr>)
                                                            }) : (<div style={{
                                                                padding: '15px',
                                                                textAlign: 'center',
                                                                color: '#666'
                                                            }}>
                                                                No risked tasks found
                                                            </div>)}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>


                                        {/* Monthly Task Status Bar Chart */}
                                        <div className='average_risk_over_time_wrapper' style={{
                                            display: 'none'
                                        }}>
                                            <h5>Monthly Task Status</h5>
                                            <div className='riskManagement_barchart_wrapper'>
                                                {loading ? (
                                                    <div className="loading-spinner">Loading...</div>
                                                ) : monthlyTaskStatusData.length > 0 ? (
                                                    <ResponsiveContainer width="100%" height={370}>
                                                        <BarChart
                                                            data={monthlyTaskStatusData}
                                                            margin={{ top: 20, right: 20, left: 20, bottom: 20 }}
                                                            stackOffset="expand"
                                                        >
                                                            <CartesianGrid strokeDasharray="3 3" />
                                                            <XAxis dataKey="name" />
                                                            <YAxis />
                                                            <Tooltip />
                                                            <Legend />
                                                            <Bar dataKey="open" stackId="a" name="Open" fill="#FFC107" />
                                                            <Bar dataKey="doing" stackId="a" name="Doing" fill="#2196F3" />
                                                            <Bar dataKey="done" stackId="a" name="Done" fill="#4CAF50" />
                                                            <Bar dataKey="ideas" stackId="a" name="Ideas" fill="#9C27B0" />
                                                            <Bar dataKey="hold" stackId="a" name="On Hold" fill="#607D8B" />
                                                        </BarChart>
                                                    </ResponsiveContainer>
                                                ) : (
                                                    <div className="no-data-message">No monthly status data available</div>
                                                )}
                                            </div>
                                        </div>
                                    </div>

                                </div>

                                <div className='risk_management_content_right' style={{
                                    display: 'none',
                                }}>
                                    <div className='risk_by_wrapper'>
                                        <h5>Task Completion Status</h5>
                                        <h6>Last update at {new Date().toLocaleString()}</h6>
                                        <Chart
                                            chartType="PieChart"
                                            width="100%"
                                            height="300px"
                                            data={transformedPieData}
                                            options={options}
                                        />
                                    </div>

                                    <div className='risk_summary_wrapper'>
                                        <h5>Risk Summary</h5>
                                        <div className='risk_summary_item'>
                                            <div className='risk_color_indicator' style={{ backgroundColor: '#4CAF50' }}></div>
                                            <span>On Time & Completed: {riskData.withinTimeAndCompleted.length}</span>
                                        </div>
                                        <div className='risk_summary_item'>
                                            <div className='risk_color_indicator' style={{ backgroundColor: '#F44336' }}></div>
                                            <span>Late & Completed: {riskData.timeCrossedAndCompleted.length}</span>
                                        </div>
                                        <div className='risk_summary_item'>
                                            <div className='risk_color_indicator' style={{ backgroundColor: '#FF9800' }}></div>
                                            <span>Late & Pending: {riskData.timeCrossedAndNotCompleted.length}</span>
                                        </div>
                                        <div className='risk_summary_item'>
                                            <div className='risk_color_indicator' style={{ backgroundColor: '#FFC107' }}></div>
                                            <span>On Time & Pending: {riskData.withinTimeAndNotCompleted.length}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    }


                    {
                        location?.pathname !== "/eventsCalender" && taskCompleteStatus && (
                            <div className='riskmanagement_dashboard_container'>
                                <div className='risk_management_content_left'>
                                    <div style={{
                                        width: "100%",
                                    }}>
                                        <div className='pro-task-wrp'>
                                            {/* Project Task Status Bar Chart */}
                                            <div className='average_risk_over_time_wrapper avregare-graph-rm' style={{
                                                width: "100%",
                                                minWidth: "100%",
                                                maxWidth: "100%",
                                            }}>
                                                <h5>Task Completion Status</h5>
                                                <div className='riskManagement_barchart_wrapper'>
                                                    {loading ? (
                                                        <div className="loading-spinner">Loading...</div>
                                                    ) : projectTaskStatusData.length > 0 ? (
                                                        <ResponsiveContainer width="100%" height={400}>
                                                            <BarChart
                                                                data={projectTaskStatusData}
                                                                margin={{ top: 20, right: 30, left: 20, bottom: 60 }}
                                                                layout="horizontal" // Changed to horizontal layout
                                                            >
                                                                <CartesianGrid strokeDasharray="3 3" />
                                                                <XAxis
                                                                    dataKey="name"
                                                                    tick={{ fontSize: 12 }}
                                                                    interval={0}
                                                                    height={70}
                                                                    angle={-45}
                                                                    textAnchor="end"
                                                                />
                                                                <YAxis
                                                                    type="number"
                                                                    label={{ value: 'Elasped Time', angle: -90, position: 'insideLeft' }}
                                                                />
                                                                <Tooltip content={<CustomTooltip />} />
                                                                <Legend />
                                                                <Bar dataKey="completionDays" name="Tasks">
                                                                    {projectTaskStatusData.map((entry, index) => (
                                                                        <Cell key={`cell-${index}`} fill={entry.color} />
                                                                    ))}
                                                                </Bar>
                                                            </BarChart>
                                                        </ResponsiveContainer>
                                                    ) : (
                                                        <div className="no-data-message">No task data available for the selected project</div>
                                                    )}
                                                </div>
                                                <div className='chart-legend' style={{ textAlign: 'center', marginTop: '10px' }}>
                                                    <div style={{ display: 'inline-block', margin: '0 10px' }}>
                                                        <span style={{ display: 'inline-block', width: '12px', height: '12px', backgroundColor: '#4CAF50', marginRight: '5px' }}></span>
                                                        <span>Completed (On Time)</span>
                                                    </div>
                                                    <div style={{ display: 'inline-block', margin: '0 10px' }}>
                                                        <span style={{ display: 'inline-block', width: '12px', height: '12px', backgroundColor: '#F44336', marginRight: '5px' }}></span>
                                                        <span>Completed (Late)</span>
                                                    </div>
                                                    <div style={{ display: 'inline-block', margin: '0 10px' }}>
                                                        <span style={{ display: 'inline-block', width: '12px', height: '12px', backgroundColor: '#FFC107', marginRight: '5px' }}></span>
                                                        <span>Pending (On Time)</span>
                                                    </div>
                                                    <div style={{ display: 'inline-block', margin: '0 10px' }}>
                                                        <span style={{ display: 'inline-block', width: '12px', height: '12px', backgroundColor: '#FF9800', marginRight: '5px' }}></span>
                                                        <span>Pending (Late)</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Monthly Task Status Bar Chart */}
                                        <div className='average_risk_over_time_wrapper' style={{
                                            display: 'none'
                                        }}>
                                            <h5>Monthly Task Status</h5>
                                            <div className='riskManagement_barchart_wrapper'>
                                                {loading ? (
                                                    <div className="loading-spinner">Loading...</div>
                                                ) : monthlyTaskStatusData.length > 0 ? (
                                                    <ResponsiveContainer width="100%" height={370}>
                                                        <BarChart
                                                            data={monthlyTaskStatusData}
                                                            margin={{ top: 20, right: 20, left: 20, bottom: 20 }}
                                                            stackOffset="expand"
                                                        >
                                                            <CartesianGrid strokeDasharray="3 3" />
                                                            <XAxis dataKey="name" />
                                                            <YAxis />
                                                            <Tooltip />
                                                            <Legend />
                                                            <Bar dataKey="open" stackId="a" name="Open" fill="#FFC107" />
                                                            <Bar dataKey="doing" stackId="a" name="Doing" fill="#2196F3" />
                                                            <Bar dataKey="done" stackId="a" name="Done" fill="#4CAF50" />
                                                            <Bar dataKey="ideas" stackId="a" name="Ideas" fill="#9C27B0" />
                                                            <Bar dataKey="hold" stackId="a" name="On Hold" fill="#607D8B" />
                                                        </BarChart>
                                                    </ResponsiveContainer>
                                                ) : (
                                                    <div className="no-data-message">No monthly status data available</div>
                                                )}
                                            </div>
                                        </div>
                                    </div>

                                </div>

                                <div className='risk_management_content_right' style={{
                                    display: 'none',
                                }}>
                                    <div className='risk_by_wrapper'>
                                        <h5>Task Completion Status</h5>
                                        <h6>Last update at {new Date().toLocaleString()}</h6>
                                        <Chart
                                            chartType="PieChart"
                                            width="100%"
                                            height="300px"
                                            data={transformedPieData}
                                            options={options}
                                        />
                                    </div>

                                    <div className='risk_summary_wrapper'>
                                        <h5>Risk Summary</h5>
                                        <div className='risk_summary_item'>
                                            <div className='risk_color_indicator' style={{ backgroundColor: '#4CAF50' }}></div>
                                            <span>On Time & Completed: {riskData.withinTimeAndCompleted.length}</span>
                                        </div>
                                        <div className='risk_summary_item'>
                                            <div className='risk_color_indicator' style={{ backgroundColor: '#F44336' }}></div>
                                            <span>Late & Completed: {riskData.timeCrossedAndCompleted.length}</span>
                                        </div>
                                        <div className='risk_summary_item'>
                                            <div className='risk_color_indicator' style={{ backgroundColor: '#FF9800' }}></div>
                                            <span>Late & Pending: {riskData.timeCrossedAndNotCompleted.length}</span>
                                        </div>
                                        <div className='risk_summary_item'>
                                            <div className='risk_color_indicator' style={{ backgroundColor: '#FFC107' }}></div>
                                            <span>On Time & Pending: {riskData.withinTimeAndNotCompleted.length}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    }



                    {
                        location?.pathname !== "/eventsCalender" && taskDeviationAnalysis && (
                            <div className='riskmanagement_dashboard_container'>
                                <div className='risk_management_content_left'>
                                    <div style={{
                                        width: "100%",
                                    }}>
                                        <div className='pro-task-wrp'>
                                            {/* Task Deviation Analysis Bar Chart */}
                                            <div className='average_risk_over_time_wrapper avregare-graph-rm' style={{
                                                width: "100%",
                                                minWidth: "100%",
                                                maxWidth: "100%",
                                            }}>
                                                <h5>Task Deviation Analysis</h5>
                                                <div className='riskManagement_barchart_wrapper'>
                                                    {loading ? (
                                                        <div className="loading-spinner">Loading...</div>
                                                    ) : deviationTaskStatusData.length > 0 ? (
                                                        <ResponsiveContainer width="100%" height={400}>
                                                            <BarChart
                                                                data={deviationTaskStatusData}
                                                                margin={{ top: 20, right: 30, left: 20, bottom: 60 }}
                                                                layout="horizontal" // Changed to horizontal layout
                                                            >
                                                                <CartesianGrid strokeDasharray="3 3" />
                                                                <XAxis
                                                                    dataKey="name"
                                                                    tick={{ fontSize: 12 }}
                                                                    interval={0}
                                                                    height={70}
                                                                    angle={-45}
                                                                    textAnchor="end"
                                                                />
                                                                <YAxis
                                                                    type="number"
                                                                    label={{ value: 'Elapsed Time', angle: -90, position: 'insideLeft' }}
                                                                />
                                                                <Tooltip content={<CustomTooltipForDevistion />} />
                                                                <Legend />
                                                                <Bar dataKey="completionDays" name="Tasks">
                                                                    {deviationTaskStatusData.map((entry, index) => (
                                                                        <Cell key={`cell-${index}`} fill={entry.color} />
                                                                    ))}
                                                                </Bar>
                                                            </BarChart>
                                                        </ResponsiveContainer>
                                                    ) : (
                                                        <div className="no-data-message">No deviation data available for the selected project</div>
                                                    )}
                                                </div>
                                                <div className='chart-legend' style={{ textAlign: 'center', marginTop: '10px' }}>
                                                    <div style={{ display: 'inline-block', margin: '0 10px' }}>
                                                        <span style={{ display: 'inline-block', width: '12px', height: '12px', backgroundColor: '#4CAF50', marginRight: '5px' }}></span>
                                                        <span>Profit (Early Completion)</span>
                                                    </div>
                                                    <div style={{ display: 'inline-block', margin: '0 10px' }}>
                                                        <span style={{ display: 'inline-block', width: '12px', height: '12px', backgroundColor: '#FFC107', marginRight: '5px' }}></span>
                                                        <span>Normal (On Time)</span>
                                                    </div>
                                                    <div style={{ display: 'inline-block', margin: '0 10px' }}>
                                                        <span style={{ display: 'inline-block', width: '12px', height: '12px', backgroundColor: '#F44336', marginRight: '5px' }}></span>
                                                        <span>Risk (Late Completion)</span>
                                                    </div>
                                                    <div style={{ display: 'inline-block', margin: '0 10px' }}>
                                                        <span style={{ display: 'inline-block', width: '12px', height: '12px', backgroundColor: '#FF9800', marginRight: '5px' }}></span>
                                                        <span>Deviation (Pending Late)</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Monthly Task Status Bar Chart */}
                                        <div className='average_risk_over_time_wrapper' style={{
                                            display: 'none'
                                        }}>
                                            <h5>Monthly Task Status</h5>
                                            <div className='riskManagement_barchart_wrapper'>
                                                {loading ? (
                                                    <div className="loading-spinner">Loading...</div>
                                                ) : monthlyTaskStatusData.length > 0 ? (
                                                    <ResponsiveContainer width="100%" height={370}>
                                                        <BarChart
                                                            data={monthlyTaskStatusData}
                                                            margin={{ top: 20, right: 20, left: 20, bottom: 20 }}
                                                            stackOffset="expand"
                                                        >
                                                            <CartesianGrid strokeDasharray="3 3" />
                                                            <XAxis dataKey="name" />
                                                            <YAxis />
                                                            <Tooltip />
                                                            <Legend />
                                                            <Bar dataKey="open" stackId="a" name="Open" fill="#FFC107" />
                                                            <Bar dataKey="doing" stackId="a" name="Doing" fill="#2196F3" />
                                                            <Bar dataKey="done" stackId="a" name="Done" fill="#4CAF50" />
                                                            <Bar dataKey="ideas" stackId="a" name="Ideas" fill="#9C27B0" />
                                                            <Bar dataKey="hold" stackId="a" name="On Hold" fill="#607D8B" />
                                                        </BarChart>
                                                    </ResponsiveContainer>
                                                ) : (
                                                    <div className="no-data-message">No monthly status data available</div>
                                                )}
                                            </div>
                                        </div>
                                    </div>

                                </div>

                                <div className='risk_management_content_right' style={{
                                    display: 'none',
                                }}>
                                    <div className='risk_by_wrapper'>
                                        <h5>Task Completion Status</h5>
                                        <h6>Last update at {new Date().toLocaleString()}</h6>
                                        <Chart
                                            chartType="PieChart"
                                            width="100%"
                                            height="300px"
                                            data={transformedPieData}
                                            options={options}
                                        />
                                    </div>

                                    <div className='risk_summary_wrapper'>
                                        <h5>Risk Summary</h5>
                                        <div className='risk_summary_item'>
                                            <div className='risk_color_indicator' style={{ backgroundColor: '#4CAF50' }}></div>
                                            <span>On Time & Completed: {riskData.withinTimeAndCompleted.length}</span>
                                        </div>
                                        <div className='risk_summary_item'>
                                            <div className='risk_color_indicator' style={{ backgroundColor: '#F44336' }}></div>
                                            <span>Late & Completed: {riskData.timeCrossedAndCompleted.length}</span>
                                        </div>
                                        <div className='risk_summary_item'>
                                            <div className='risk_color_indicator' style={{ backgroundColor: '#FF9800' }}></div>
                                            <span>Late & Pending: {riskData.timeCrossedAndNotCompleted.length}</span>
                                        </div>
                                        <div className='risk_summary_item'>
                                            <div className='risk_color_indicator' style={{ backgroundColor: '#FFC107' }}></div>
                                            <span>On Time & Pending: {riskData.withinTimeAndNotCompleted.length}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    }



                    {
                        location?.pathname !== "/eventsCalender" && taskAtRisk && (
                            <div className='riskmanagement_dashboard_container'>
                                <div className='risk_management_content_left'>
                                    <div style={{
                                        width: "100%",
                                    }}>
                                        {/** Risked Tasks Table **/}
                                        <div className='average_risk_over_time_wrapper' style={{
                                            width: '100%',
                                            minWidth: "100%",
                                            maxWidth: "100%",
                                        }}>
                                            <h5>Tasks At-Risk</h5>
                                            {/* Table container with fixed height and scroll */}
                                            <div style={{
                                                maxHeight: '300px',
                                                overflow: 'auto',
                                                marginTop: '10px',
                                                border: '1px solid #e0e0e0',
                                                borderRadius: '4px'
                                            }}>
                                                <table style={{
                                                    width: '100%',
                                                    borderCollapse: 'collapse'
                                                }}>
                                                    <thead style={{
                                                        position: 'sticky',
                                                        top: 0,
                                                        backgroundColor: '#0C2537',
                                                        color: 'white',
                                                        fontSize: '13px'
                                                    }}>
                                                        <tr>
                                                            <th style={{ padding: '8px', textAlign: 'left' }}>Task Name</th>
                                                            <th style={{ padding: '8px', textAlign: 'left' }}>Team Member</th>
                                                            <th style={{ padding: '8px', textAlign: 'left' }}>Task Status</th>
                                                            <th style={{ padding: '8px', textAlign: 'left' }}>Days Behind</th>
                                                            <th style={{ padding: '8px', textAlign: 'left' }}>Days Past Due</th>
                                                            <th style={{ padding: '8px', textAlign: 'left' }}>Remaining Days</th>
                                                            <th style={{ padding: '8px', textAlign: 'left' }}>Task Completion Date</th>
                                                            <th style={{ padding: '8px', textAlign: 'left' }}>Task Due Date</th>
                                                            <th style={{ padding: '8px', textAlign: 'left' }}>Project Due Date</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            taskAtRiskData?.length > 0 ? taskAtRiskData?.map((task, index) => {

                                                                return (<tr key={index} style={{
                                                                    borderBottom: '1px solid #e0e0e0',
                                                                    // backgroundColor: index % 2 === 0 ? '#f9f9f9' : 'white'
                                                                }}>
                                                                    <td style={{ padding: '8px' }}>{task.taskName || '-'}</td>
                                                                    <td style={{ padding: '8px', textAlign: 'center' }}>
                                                                        <button
                                                                            onClick={() => handleShowUsers(task?.assignedUsers || [])}
                                                                            style={{
                                                                                background: 'none',
                                                                                border: 'none',
                                                                                cursor: 'pointer',
                                                                                color: '#0C2537',
                                                                                fontSize: '16px'
                                                                            }}
                                                                            title="View Assigned Users"
                                                                        >
                                                                            <i className="fa-solid fa-eye"></i>
                                                                        </button>
                                                                    </td>
                                                                    <td style={{ padding: '8px' }}>{task?.statusNote || '-'}</td>
                                                                    <td style={{
                                                                        padding: '8px',
                                                                        color: task?.daysBehind < 0 ? 'red' : task?.daysBehind > 0 ? 'green' : 'inherit'
                                                                    }}>{task?.doneOn ? task?.daysBehind : '-'}</td>
                                                                    <td style={{
                                                                        padding: '8px',
                                                                        color: task?.pastDue < 0 ? 'red' : task?.pastDue > 0 ? 'green' : 'inherit'
                                                                    }}>{task?.pastDue}</td>
                                                                    <td style={{
                                                                        padding: '8px',
                                                                        color: task?.remainingDays < 0 ? 'red' : task?.remainingDays > 0 ? 'green' : 'inherit'
                                                                    }}>{task?.remainingDays}</td>
                                                                    <td style={{ padding: '8px' }}>{task?.doneOn ? moment(task.doneOn).format('MMM D, YYYY') : '-'}</td>
                                                                    <td style={{ padding: '8px' }}>
                                                                        {task.endDate ? moment(task.endDate).format('MMM D, YYYY') : '-'}
                                                                    </td>
                                                                    <td style={{ padding: '8px' }}>
                                                                        {moment(task.projectEndDate).format('MMM D, YYYY')}
                                                                    </td>
                                                                </tr>)
                                                            }) : (<div style={{
                                                                padding: '15px',
                                                                textAlign: 'center',
                                                                color: '#666'
                                                            }}>
                                                                No risked tasks found
                                                            </div>)}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>


                                        {/* Monthly Task Status Bar Chart */}
                                        <div className='average_risk_over_time_wrapper' style={{
                                            display: 'none'
                                        }}>
                                            <h5>Monthly Task Status</h5>
                                            <div className='riskManagement_barchart_wrapper'>
                                                {loading ? (
                                                    <div className="loading-spinner">Loading...</div>
                                                ) : monthlyTaskStatusData.length > 0 ? (
                                                    <ResponsiveContainer width="100%" height={370}>
                                                        <BarChart
                                                            data={monthlyTaskStatusData}
                                                            margin={{ top: 20, right: 20, left: 20, bottom: 20 }}
                                                            stackOffset="expand"
                                                        >
                                                            <CartesianGrid strokeDasharray="3 3" />
                                                            <XAxis dataKey="name" />
                                                            <YAxis />
                                                            <Tooltip />
                                                            <Legend />
                                                            <Bar dataKey="open" stackId="a" name="Open" fill="#FFC107" />
                                                            <Bar dataKey="doing" stackId="a" name="Doing" fill="#2196F3" />
                                                            <Bar dataKey="done" stackId="a" name="Done" fill="#4CAF50" />
                                                            <Bar dataKey="ideas" stackId="a" name="Ideas" fill="#9C27B0" />
                                                            <Bar dataKey="hold" stackId="a" name="On Hold" fill="#607D8B" />
                                                        </BarChart>
                                                    </ResponsiveContainer>
                                                ) : (
                                                    <div className="no-data-message">No monthly status data available</div>
                                                )}
                                            </div>
                                        </div>
                                    </div>

                                </div>

                                <div className='risk_management_content_right' style={{
                                    display: 'none',
                                }}>
                                    <div className='risk_by_wrapper'>
                                        <h5>Task Completion Status</h5>
                                        <h6>Last update at {new Date().toLocaleString()}</h6>
                                        <Chart
                                            chartType="PieChart"
                                            width="100%"
                                            height="300px"
                                            data={transformedPieData}
                                            options={options}
                                        />
                                    </div>

                                    <div className='risk_summary_wrapper'>
                                        <h5>Risk Summary</h5>
                                        <div className='risk_summary_item'>
                                            <div className='risk_color_indicator' style={{ backgroundColor: '#4CAF50' }}></div>
                                            <span>On Time & Completed: {riskData.withinTimeAndCompleted.length}</span>
                                        </div>
                                        <div className='risk_summary_item'>
                                            <div className='risk_color_indicator' style={{ backgroundColor: '#F44336' }}></div>
                                            <span>Late & Completed: {riskData.timeCrossedAndCompleted.length}</span>
                                        </div>
                                        <div className='risk_summary_item'>
                                            <div className='risk_color_indicator' style={{ backgroundColor: '#FF9800' }}></div>
                                            <span>Late & Pending: {riskData.timeCrossedAndNotCompleted.length}</span>
                                        </div>
                                        <div className='risk_summary_item'>
                                            <div className='risk_color_indicator' style={{ backgroundColor: '#FFC107' }}></div>
                                            <span>On Time & Pending: {riskData.withinTimeAndNotCompleted.length}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    }
                </div>

            </div>

            {/* User Modal */}
            {showUserModal && (
                <UserModal
                    users={selectedTaskUsers}
                    onClose={() => setShowUserModal(false)}
                />
            )}

        </div>
    )
}

export default RiskManagement